// extracted by mini-css-extract-plugin
export var addressFields = "_nt-0";
export var animationContainer = "_nt-1";
export var footer = "_nt-2";
export var lineItems = "_nt-3";
export var modalContent = "_nt-4";
export var orderName = "_nt-5";
export var strong = "_nt-6";
export var warning = "_nt-7";